module.exports = __webpack_public_path__ + "img/page1-bg-phone.705eb9b2.png";